//Built-in libraries
//Third party libraries

//Custom components
import Unauthorized from '@/components/Unauthorized';
//Features
import { ProjectsList } from '@/features/projects';

//Services
import { usePermission } from '../../../hooks/usePermission';

const Projects = () => {
  const { hasPermission } = usePermission();
  if (hasPermission(['LIST_ALL_PROJECTS', 'LIST_PROJECTS'])) {
    return <ProjectsList />;
  }
  return <Unauthorized />;
};

export default Projects;
